import {
  ACCESS,
  ADD,
  AGENT_TOOLS,
  EDIT,
  ENVIRONMENTS,
  LICENSES,
  LOGS,
  LOG_OUT,
  MY_ACCOUNT,
  SETTINGS,
  SPACES,
  SPACE_API_ACCESS,
  STATUS,
  SYSTEM
} from '@eggplant/routing'

export const pathToRetainUponRefresh = [
  `/${SPACES}`,
  `/${SPACE_API_ACCESS}`,
  `/${SPACE_API_ACCESS}/${ADD}`,
  `/${SPACE_API_ACCESS}/:apiAccessId/${EDIT}`,
  `/${ENVIRONMENTS}`,
  `/${ENVIRONMENTS}/:environmentId/${EDIT}`,
  `/${ENVIRONMENTS}/${ADD}`,
  `/${SYSTEM}/${STATUS}`,
  `/${SYSTEM}/${ACCESS}`,
  `/${SYSTEM}/${MY_ACCOUNT}`,
  `/${SYSTEM}/${LICENSES}`,
  `/${SYSTEM}/${LOGS}`,
  `/${SYSTEM}/${AGENT_TOOLS}`,
  `/${SYSTEM}/${SETTINGS}`,
  `/${LOG_OUT}`
]
